import styled from "@emotion/styled";

export const TitleH4 = styled.h4`
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    
    @media (min-width: ${p => p.theme.screenSizes.mdMax}) {
        font-size: 20px;
    }
   
}
`;
